/**
 * Park lookup catalog for search and zoom.
 */

/**
 * @param {object} park
 */
export function formatParkLabel(park) {
    const ref = park.ref || park.NAME || '';
    const title = park.title || park.TITLE || '';
    if (ref && title) {
        return `${ref} — ${title}`;
    }
    return ref || title || '';
}

/**
 * @param {object} featureProps
 * @param {{ lat: number, lon: number }} coords
 */
export function parkSearchItemFromProps(featureProps, coords) {
    const ref = featureProps.reference || featureProps.NAME || null;
    const title = featureProps.title || featureProps.TITLE || featureProps.sourceName || '';
    const park = {
        ref,
        title,
        grid: featureProps.GRID || featureProps.grid || null,
        lat: coords.lat,
        lon: coords.lon,
    };

    return {
        label: formatParkLabel(park),
        value: ref || title,
        ref,
        title,
        grid: park.grid || '',
        lat: park.lat,
        lon: park.lon,
    };
}

/**
 * @param {object[]} items
 * @param {string} query
 */
export function findParkSearchMatch(items, query) {
    const q = String(query || '').trim().toLowerCase();
    if (!q || !items?.length) {
        return null;
    }

    const exact = items.find((item) => {
        const ref = String(item.ref || item.value || '').toLowerCase();
        return ref === q;
    });
    if (exact) {
        return exact;
    }

    const startsWith = items.find((item) => item.label.toLowerCase().startsWith(q));
    if (startsWith) {
        return startsWith;
    }

    return items.find((item) => {
        const haystack = [
            item.label,
            item.ref,
            item.title,
            item.grid,
        ].join(' ').toLowerCase();
        return haystack.includes(q);
    }) || null;
}
